import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';

import FunctionalUtils from 'mewe/shared/functional-utils';
import GroupApi from 'mewe/api/group-api';

export default Route.extend({
  theme: 'group',

  queryParams: {
    initialTabNumber: {
      refreshModel: false,
    },
  },

  model(params) {
    const groupId = this.paramsFor('app.group').group_id;

    let model = EmberObject.create({
      settings: null,
      initialTabNumber: parseInt(params.initialTabNumber, 10),
      group: this.modelFor('app.group').group,
    });

    GroupApi.getSettings(groupId)
      .then((data) => {
        model.set('settings', EmberObject.create(data));
      })
      .catch(() => {
        FunctionalUtils.showDefaultErrorMessage();
      });

    return model;
  },
});
